const constants = {
  EXERCISES_LOADING_START: 'EXERCISES_LOADING_START',
  EXERCISES_LOADING_END: 'EXERCISES_LOADING_END',
  EXERCISES_UPDATE: 'EXERCISES_UPDATE',
  EXERCISES_SELECT: 'EXERCISES_SELECT',
  EXERCISES_DELETE_OK: 'EXERCISES_DELETE_OK',
  EXERCISES_CHANGE_FILTER: 'EXERCISES_CHANGE_FILTER',
  EXERCISES_RESET_FILTER: 'EXERCISES_RESET_FILTER',
};

export default constants;
